import { authHeader, handleResponse } from '../utils'
import { API_BASE } from '../config/constants'


const sendSearchRequest = async (artworkId, patternUrl) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            artworkId,
            patternUrl
        })
    }
    const response = fetch(`${API_BASE}/safety/sendSearchRequest`, requestOptions)
    return await handleResponse(response);
};

const sendSearchRequestByName = async (artworkId, Term) => {

    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            artworkId,
            Term
        })
    }
    const response = fetch(`${API_BASE}/safetyterm/sendSearchRequest`, requestOptions)
    return await handleResponse(response);
};

const getOneSafetyInfo = async(artworkId) => {
    const requestOptions = {
        method: 'POST',
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            artworkId,
        })
    }
    const response = fetch(`${API_BASE}/safety/getOneSafetyInfo`, requestOptions)
    return await handleResponse(response);
}

const getOneSafetyInfoName = async(artworkId) => {
    const requestOptions = {
        method: 'POST', 
        headers: { ...authHeader(), 'Content-Type': 'application/json' },
        body: JSON.stringify({
            artworkId,
        })
    }
    const response = fetch(`${API_BASE}/safetyterm/getOneSafetyTermInfo`, requestOptions)
    return await handleResponse(response);
}

export const safetyService = {
    sendSearchRequest,
    sendSearchRequestByName,
    getOneSafetyInfo,
    getOneSafetyInfoName
}